<template>
    <el-card shadow="hover">
        <label slot="header">所属区域选框 {{`${gridCode}`}}(规则 4:市，6:区/县，9：街道，12：社区，14：网格)</label>
        需要往store.js注入JGridCtrl模块
        import { JGridCtrl } from './components/JGridCtrl/store'
        使用时需要确认项目，最大区域级别，设置rule规则
        <el-divider content-position="left">type="text" :value="gridCode" textSeparator="/"， 默认分隔符textSeparator="-"</el-divider>
        <j-grid-ctrl style="color: #409EFF;" type="text" :value="gridCode" textSeparator="/" :rule="[9, 12, 14]" />
        <el-divider content-position="left">type="select" placeholder="请选择区域" v-model="gridCode"</el-divider>
        <j-grid-ctrl type="select" placeholder="请选择区域" v-model="gridCode" :rule="[9, 12, 14]" />
        <el-divider content-position="left">type="text" value="12011000101004" :rule="[9, 12, 14]" 默认规则是[6, 9, 12, 14]，可根据后端返回的层级解析</el-divider>
        <div style="color: #F56C6C;margin-bottom: 10px;">
            rule[6, 9, 12, 14] : <j-grid-ctrl type="text" value="12011000101004" />
        </div>
        <div style="color: #409EFF">
            rule[9, 12, 14] : <j-grid-ctrl type="text" value="12011000101004" :rule="[9, 12, 14]" />
        </div>
        <el-divider content-position="left">多选:multiple="true"</el-divider>
        <j-grid-ctrl type="select" multiple v-model="multipleGridCode" :rule="[9, 12]" @change="multipleChange" />
        <j-grid-ctrl type="text" multiple v-model="multipleGridCode" :rule="[9, 12]" />
    </el-card>
</template>

<script>
    import JGridCtrl from "./JGridCtrl";
    export default {
        components: {
            JGridCtrl
        },
        data() {
            return {
                gridCode: '',
                multipleGridCode: ''
            }
        },
        created() {

        },
        methods: {
          multipleChange (v) {
            console.log(v)
          }
        }
    }
</script>

<style scoped>

</style>
